import { render, staticRenderFns } from "./AILetterDraftBtn.vue?vue&type=template&id=264d8512"
import script from "./AILetterDraftBtn.vue?vue&type=script&lang=js"
export * from "./AILetterDraftBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports